import { useEffect } from 'react';
import { IconChartHistogram } from '@tabler/icons-react';

import { useScreen } from 'Screen/ScreenContext';

import useInsights from './hooks/useInsights';
import CurrencyBar from './view/components/CurrencyBar';
import InsightsView from './view';

export default function Insights() {
    document.title = 'Insights | Ginastee';

    const { setBreadcrumb, setBreadcrumbAction } = useScreen();
    const insights = useInsights();

    const {
        ownedCommunities,
        community,
        setCommunity,
        plansByCommunity,
        selectedCurrency,
        setSelectedCurrency,
    } = insights;

    useEffect(() => {
        setBreadcrumb([
            { label: 'Insights', href: '/insights', icon: <IconChartHistogram size={18} /> },
            { label: 'Relatório de vendas' },
        ]);
        return () => setBreadcrumb(null);
    }, [setBreadcrumb]);

    // Render the community/currency selector as a block beside the breadcrumb pill
    // (fixed on scroll). Re-set when its inputs change so it tracks hook state.
    useEffect(() => {
        setBreadcrumbAction(
            ownedCommunities.length ? (
                <CurrencyBar
                    ownedCommunities={ownedCommunities}
                    community={community}
                    setCommunity={setCommunity}
                    plansByCommunity={plansByCommunity}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                />
            ) : null
        );
    }, [ownedCommunities, community, plansByCommunity, selectedCurrency, setCommunity, setSelectedCurrency, setBreadcrumbAction]);

    // Clear the action when leaving the page.
    useEffect(() => () => setBreadcrumbAction(null), [setBreadcrumbAction]);

    return <InsightsView {...insights} />;
}
